const t = (e) => (globalThis == null ? void 0 : globalThis.requestAnimationFrame) !== void 0 ? globalThis.requestAnimationFrame(e) : setTimeout(e, 16);
export {
  t as requestAnimationFrame
};
